import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";
import { presetToRange } from "@/lib/format";
import { useAuth } from "@/context/AuthContext";

const FilterContext = createContext(null);

export function FilterProvider({ children }) {
  const { user, isCorporate } = useAuth();
  const [brands, setBrands] = useState([]);
  const [preset, setPreset] = useState("90d");
  const [range, setRange] = useState(presetToRange("90d"));
  // corporate: "all" or brand_id ; manager: locked to first allowed brand
  const [brandId, setBrandId] = useState("all");

  useEffect(() => {
    if (!user) return;
    api.get("/brands").then((res) => {
      setBrands(res.data);
      if (!isCorporate && res.data.length > 0) {
        setBrandId(res.data[0].id);
      }
    });
  }, [user, isCorporate]);

  const applyPreset = (key) => {
    setPreset(key);
    setRange(presetToRange(key));
  };

  const setCustomRange = (start_date, end_date) => {
    setPreset("custom");
    setRange({ start_date, end_date });
  };

  // query params helper for API calls
  const queryParams = useMemo(() => {
    const p = {};
    if (range.start_date) p.start_date = range.start_date;
    if (range.end_date) p.end_date = range.end_date;
    if (isCorporate && brandId && brandId !== "all") p.brand_id = brandId;
    if (!isCorporate && brandId && brandId !== "all") p.brand_id = brandId;
    return p;
  }, [range, brandId, isCorporate]);

  const nonCorpBrands = useMemo(() => brands.filter((b) => !b.is_corporate), [brands]);

  const currentBrandName = useMemo(() => {
    if (isCorporate && (brandId === "all" || !brandId)) return "All Brands";
    const b = brands.find((x) => x.id === brandId);
    return b ? b.name : "\u2014";
  }, [brandId, brands, isCorporate]);

  return (
    <FilterContext.Provider
      value={{
        brands,
        nonCorpBrands,
        preset,
        range,
        applyPreset,
        setCustomRange,
        brandId,
        setBrandId,
        queryParams,
        currentBrandName,
      }}
    >
      {children}
    </FilterContext.Provider>
  );
}

export const useFilters = () => useContext(FilterContext);
